"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledDialogClose = void 0;
var _DialogClose = require("./DialogClose");
// TODO: in v9, move styled() from DialogClose.jsx to here
var StyledDialogClose = _DialogClose.DialogClose;
exports.StyledDialogClose = StyledDialogClose;